import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../auth.service';

/**
 * Guard funcional que protege rutas que solo deben ser accesibles por usuarios con tenant.
 * Platform Admins (tenantId = null) son redirigidos a la página de gestión de tenants.
 */
export const tenantGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.getCurrentUser();

  // Usuario debe tener TenantId (NO ser Platform Admin)
  if (user && user.tenantId !== null) {
    return true;
  }

  // Redirect to platform admin area if not a tenant user
  return router.createUrlTree(['/dashboard/platform-admin/tenants']);
};
